import { Link } from 'react-router-dom';
import PhotoPlaceholder from '../components/photo-placeholder';
import { CATS, TRAT } from '../data/services';
import { eyebrow, h1, bodyText, pageWrap } from '../lib/styles';

function precioDesde(catId) {
  const precios = (TRAT[catId] ?? []).map((t) => Number(t.precio.replace(/\D/g, '')));
  return precios.length ? `$${Math.min(...precios)}` : '—';
}

const Services = () => (
  <div style={pageWrap}>
    <span style={eyebrow}>Servicios</span>
    <h1 style={h1}>Todo lo que hacemos en Zenya</h1>
    <p style={{ ...bodyText, maxWidth: '56ch', margin: '0 0 4vw' }}>
      Entra a cada área para ver los tratamientos, lo que incluyen, cuánto duran y cuánto cuestan.
    </p>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))',
        gap: 22,
        paddingBottom: '4vw',
      }}
    >
      {CATS.map((c) => (
        <article
          key={c.id}
          style={{
            background: '#FFF',
            border: '1px solid var(--ink-200)',
            borderRadius: 'var(--radius-xl)',
            overflow: 'hidden',
            boxShadow: 'var(--shadow-sm)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <PhotoPlaceholder
            label={c.nombre}
            ratio="16/10"
            style={{ borderRadius: 0, border: 'none', borderBottom: '1px dashed var(--rose-200)' }}
          />
          <div style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 400,
                fontSize: 26,
                color: 'var(--ink-900)',
                margin: 0,
              }}
            >
              {c.nombre}
            </h2>
            <span style={{ fontSize: 11, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-500)' }}>
              {(TRAT[c.id] ?? []).length} tratamientos · desde {precioDesde(c.id)}
            </span>
            <p style={{ fontSize: 14.5, lineHeight: 1.65, color: 'var(--ink-600)', margin: 0, flex: 1 }}>{c.desc}</p>
            <Link
              to={`/servicios/${c.id}`}
              style={{ color: 'var(--rose-700)', fontSize: 13.5, letterSpacing: '.08em', textTransform: 'uppercase' }}
            >
              {c.cta} →
            </Link>
          </div>
        </article>
      ))}
    </div>
  </div>
);

export default Services;
